import { GroupOrgs } from "@/common/api.service";
import {
  FETCH_GROUP_ORGS,
  FETCH_GROUP_ORGS_LIST,
  FETCH_GROUP_ORGS_LIZING
} from "./actions.type";
import {
  FETCH_GROUP_ORGS_END,
  FETCH_GROUP_ORGS_START,
  FETCH_GROUP_ORGS_LIZING_START,
  FETCH_GROUP_ORGS_LIZING_END
} from "@/store/mutations.type";

const state = {
  groupOrg: {},
  isGroupOrgsLoading: false,
  isGroupOrgsLisingLoading: false,
  groupOrgs: [],
  getListOrgsLizing: []
};

const getters = {
  groupOrg() {
    return state.groupOrg;
  },
  isGroupOrgsLoading() {
    return state.isGroupOrgsLoading;
  },
  isGroupOrgsLisingLoading() {
    return state.isGroupOrgsLisingLoading;
  },
  groupOrgs() {
    return state.groupOrgs;
  },
  getListOrgsLizing() {
    return state.getListOrgsLizing;
  }
};

const actions = {
  async [FETCH_GROUP_ORGS]({ commit }, params) {
    await GroupOrgs.getListOrgs(params)
      .then(({ data }) => {
        commit(FETCH_GROUP_ORGS_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_GROUP_ORGS_LIST]({ commit }, params) {
    commit(FETCH_GROUP_ORGS_START);
    return GroupOrgs.getListGroupOrgs(params)
      .then(({ data }) => {
        commit(FETCH_GROUP_ORGS_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  },
  async [FETCH_GROUP_ORGS_LIZING]({ commit }, params) {
    await GroupOrgs.getListOrgsLizing(params)
      .then(({ data }) => {
        commit(FETCH_GROUP_ORGS_LIZING_END, data);
      })
      .catch(error => {
        throw new Error(error);
      });
  }
};

const mutations = {
  [FETCH_GROUP_ORGS_START](state) {
    state.isGroupOrgsLoading = true;
  },
  [FETCH_GROUP_ORGS_END](state, groupOrgs) {
    state.groupOrgs = groupOrgs;
    state.isGroupOrgsLoading = false;
  },
  [FETCH_GROUP_ORGS_LIZING_START](state) {
    state.isGroupOrgsLizingLoading = true;
  },
  [FETCH_GROUP_ORGS_LIZING_END](state, getListOrgsLizing) {
    state.getListOrgsLizing = getListOrgsLizing;
    state.isGroupOrgsLisingLoading = false;
  }
};

export default {
  state,
  getters,
  actions,
  mutations
};
